import type { ScriptStatus } from '../../../shared/types';

export interface StatusPillLabel {
  /** lg and up. */
  full: string;
  /** md to lg. */
  short: string;
  /** below md. */
  phone: string;
}

/**
 * The pill's own wording. Deliberately not `STATUS_LABELS` from shared/types:
 * that map is also the dashboard's, the bundle editor's and both PDFs', where
 * "V2" is right. In the bar there is room to say "Round 2", and on a phone
 * "Approved" plus the whole rail does not fit 360px, so it reads "Final" —
 * which is what the status menu's own hint already calls it.
 */
export const STATUS_PILL_LABELS: Record<ScriptStatus, StatusPillLabel> = {
  draft: { full: 'Draft', short: 'Draft', phone: 'Draft' },
  v1: { full: 'Round 1', short: 'R1', phone: 'R1' },
  v2: { full: 'Round 2', short: 'R2', phone: 'R2' },
  v3: { full: 'Round 3', short: 'R3', phone: 'R3' },
  approved: { full: 'Approved', short: 'Approved', phone: 'Final' },
};
